import React,{useEffect,useState} from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";

interface IProps {
    scoreValue?: number;
    scoreRating?: string;
    status?: string;
    title?: string;
    logo?: string;
    image?: string;
    updated?: string;
    population?: number;
    isIDFUser?: boolean;
    isTUUser?: boolean;
}

const CreditScoreType: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const [partnerPhoneNumber, setPartnerPhoneNumber] = useState('');
    useEffect(() => {
        setPartnerPhoneNumber(sessionStorage.getItem('partnerPhoneNumber'))
    }, [])
    return (
        <li>
            <div className="m-credit-bureau-container">
                {!props.scoreValue ?
                    <div className="credit-bureau-text">
                        <div className="sys-msg-content" style={{ fontWeight: "600" }}>
                            <span className="error-icon">
                                <em className="las la-exclamation-triangle" style={{ fontSize: "1.2rem", color: "#ab170d" }}></em>&nbsp;
                                <p style={{ fontWeight: "600", display: "inline" }}>{tLang("credit.creditScore.bannerMessage.title")}</p>
                            </span>
                        </div>
                        <div style={{marginTop: "1rem"}}>
                            <p>
                                {tLang("credit.creditScore.bannerMessage.msg1")}{" "}
                                {props.title}{" "}
                                {tLang("credit.creditScore.bannerMessage.msg2")}{" "}
                                <span style={{ fontWeight: "600" }}>{tLang("credit.creditScore.bannerMessage.msg3")}</span>{" "}
                                {tLang("credit.creditScore.bannerMessage.msg4")}{" "}
                                {partnerPhoneNumber}.
                            </p>
                        </div>
                        {props.logo != null && props.logo !== "" ? (
                            <div className="credit-bureau-logo">
                                <img src={props.logo} alt={props.title + " Logo"} />
                            </div>
                        ) : null}
                    </div> :
                    <>
                        <div className={`credit-bureau-score ${props.status}`}>
                            <h2 className="credit-bureau-score-value">{props.scoreValue}</h2>
                            <div className="credit-bureau-score-rating">{props.scoreRating}</div>
                        </div>
                        <div className="credit-bureau-text">
                            <h3 className="credit-bureau-title" id={`cb-title-${props.title}`}>
                                {props.title + " "} <span className="sr-only">{tLang("dashboard.creditScore.title")}</span>
                            </h3>

                            {props.logo != null && props.logo !== "" ? (
                                <div className="credit-bureau-logo">
                                    <img src={props.logo} alt={props.title + " Logo"} />
                                </div>
                            ) : null}

                            <p>
                                {props.updated != null && props.updated !== "" ? (
                                    <small>
                                        <strong>
                                            {tLang("credit.creditScore.creditScoreWidget.label.updatedDate")} {getFormattedDate(i18nService.get("Country"), props.updated)}
                                        </strong>
                                    </small>
                                ) : null}
                            </p>

                            <div className="spacer"></div>

                            {props.isIDFUser || props.isTUUser ? (
                                <div className={`msg-generic msg-small msg-no-background ${!props.population ? 'msg-no-text': null}`}>
                                    {props.population && (
                                        <>
                                            <em className="las la-info-circle"></em>{" "}
                                            {tLang("credit.creditScore.creditScoreWidget.label.scorePlaces", { perc: props.population })}
                                        </>
                                    )}
                                </div>                            
                            ) : (
                            <div className="msg-generic msg-small msg-no-background">
                                <em className="las la-info-circle"></em> {tLang("credit.creditScore.creditScoreWidget.label.scoreDescriptionExperian")}
                                </div>
                            )}
                        </div>
                    </>
            }  
            </div>
        </li>
    );
};

export default CreditScoreType;
